/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import React from 'react';
import { gql, useQuery } from '@apollo/client';
import CONFIG from '../../config';


interface Terms {
  termsOfUse: any;
}

interface QueryResult {
  termsOfUseAndPrivacyPolicy: Terms;
}

const FeedQuery = gql`
  query ($id: ID!) {
    termsOfUseAndPrivacyPolicy (where: { id: $id } , stage: PUBLISHED) {
      termsOfUse {
        html
        }
    }
  }
`;

export const TermsOfUse = () => {
  const { data, error } = useQuery<QueryResult>(FeedQuery, {
    variables: {
      id: CONFIG.graphCMSLegalId
    },
  });

  if (error || !data?.termsOfUseAndPrivacyPolicy) {
    return <></>
  }
  return (
    <div className='legal'>
      <div
        className='solution-text'
        dangerouslySetInnerHTML={{ __html: data.termsOfUseAndPrivacyPolicy.termsOfUse.html }}
      />
    </div>
  )
}

